import { gql } from "@apollo/client";

export const AssetSpecifications = gql`
    query AssetSpecifications ($id: ID!) {
        assetLocation (id: $id) {
            id
            owner {
                id
                name
                contract {
                    id
                    contractType
                }
                address {
                    id
                    title
                    street
                    houseNumber
                    additionalInformation
                    postalCode
                    city
                    stateOrRegion
                    country { name }
                    geoLocation { latitude longitude }
                }
            }
            address {
                id
                title
                street
                houseNumber
                additionalInformation
                postalCode
                city
                stateOrRegion
                country { name }
                geoLocation { latitude longitude }
            }
            iotConnection {
                id
                oilCategory
                oilType
                operatingFrequency
                acousticEnclosure
                gateway {
                    id
                    imei
                }
            }
            installedBaseNode {
                id
                attributeList {
                    total
                    attributes {
                        id
                        title
                        value
                        property {
                            id
                            preferredName
                        }
                    }
                }
            }
            attributeList {
                total
                attributes {
                    id
                    displayValue
                    unit
                    property {
                        id
                        preferredName
                        unit {
                            id
                            label
                        }
                    }
                }
            }
            asset {
                id
                urn
                serialNumber
                manufacturer {
                    id
                    name
                }
                dateOfManufacture
                product {
                    id
                    name
                    productCode
                    productCategory {
                        id
                        name
                    }
                    characteristicAttributeList {
                        total
                        attributes {
                            id
                            displayValue
                            unit
                            property {
                                id
                                preferredName
                                propertyDefinitionCategory
                                propertyDefinitionSubCategory
                                unit {
                                    id
                                    label
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
